<div class="modal-header">
	<h4 class="modal-title" id="modal-basic-title">
		<i class="bi bi-stars me-2"></i>

		@if (sourceMaterialService.SelectedArticles.length === 0) {
			Luo peli
		} @else {
			Luo peli valituista ({{
				sourceMaterialService.SelectedArticles.length
			}})

			<!-- <span class="badge rounded-pill bg-primary ms-2">
				{{ sourceMaterialService.SelectedArticles.length }}
			</span> -->
		}
	</h4>

	<button
		type="button"
		class="btn-close"
		aria-label="Close"
		(click)="CloseModal()"
	></button>
</div>
<div class="modal-body p-0">
	<!-- Banner/Hero section with subtle background pattern -->
	<!-- <div
		class="bg-light p-4 mb-4"
		style="
			background-image: url(&quot;assets/metapress_logo_light.png&quot;);
			background-size: 300px;
			background-repeat: no-repeat;
			background-position: right 10px top 10px;
			background-opacity: 0.1;
		"
	>
		<h2 class="mb-3">Valitse pelipohja</h2>
		<p class="lead">
			Pelivalikoimamme tarjoaa laajan valikoiman erilaisia pelipohjia,
			jotka on suunniteltu erityisesti MetaPress-alustalle.
		</p>
	</div> -->

	<!-- Main content with featured games -->
	<div class="container-fluid px-5 pt-4">
		<!-- Filter and Search Controls - Single Row -->
		<div class="row mb-3 align-items-center">
			<div class="col-lg-3 d-none d-lg-block">
				<!-- Search Bar -->
				<div class="input-group">
					<span class="input-group-text">
						<i class="bi bi-search"></i>
					</span>
					<input
						type="text"
						class="form-control"
						placeholder="Hae pelejä nimen tai kuvauksen mukaan..."
						[(ngModel)]="searchText"
						aria-label="Hae pelejä"
					/>
				</div>
			</div>

			<div class="col-auto">
				<!-- View Toggle Button Group -->
				<div class="d-flex justify-content-center">
					<div class="btn-group" role="group" aria-label="View mode">
						<button
							type="button"
							class="btn btn-outline-secondary"
							[class.active]="viewMode === 'cards'"
							(click)="toggleViewMode('cards')"
							title="Kortit"
						>
							<i class="bi bi-grid-3x3-gap"></i>
						</button>
						<button
							type="button"
							class="btn btn-outline-secondary"
							[class.active]="viewMode === 'rows'"
							(click)="toggleViewMode('rows')"
							title="Rivit"
						>
							<i class="bi bi-list"></i>
						</button>
					</div>
				</div>
			</div>

			@if (showUnfinishedPlugins) {
				<div class="d-none d-lg-block col-lg">
					<!-- State Filter Buttons -->
					<div class="d-flex align-items-end justify-content-end">
						<!-- <label class="form-label me-2 mb-0">Tila:</label> -->
						<div class="dropdown" ngbDropdown>
							<button
								class="btn btn-outline-primary dropdown-toggle"
								type="button"
								ngbDropdownToggle
								id="stateDropdown"
								aria-expanded="false"
							>
								<i class="bi bi-funnel me-2"></i>
								Versiot
								@if (selectedStates.length > 0) {
									<span class="badge bg-primary ms-2">{{
										selectedStates.length
									}}</span>
								}
							</button>
							<ul
								class="dropdown-menu"
								ngbDropdownMenu
								aria-labelledby="stateDropdown"
							>
								<li>
									<label class="dropdown-item">
										<input
											type="checkbox"
											class="form-check-input me-2"
											[checked]="
												isStateSelected(
													GameProductionState.Production
												)
											"
											(change)="
												toggleState(
													GameProductionState.Production
												)
											"
										/>
										Tuotanto
									</label>
								</li>
								<li>
									<label class="dropdown-item">
										<input
											type="checkbox"
											class="form-check-input me-2"
											[checked]="
												isStateSelected(
													GameProductionState.Beta
												)
											"
											(change)="
												toggleState(
													GameProductionState.Beta
												)
											"
										/>
										Beta
									</label>
								</li>
								<li>
									<label class="dropdown-item">
										<input
											type="checkbox"
											class="form-check-input me-2"
											[checked]="
												isStateSelected(
													GameProductionState.Alpha
												)
											"
											(change)="
												toggleState(
													GameProductionState.Alpha
												)
											"
										/>
										Alpha
									</label>
								</li>
								<li>
									<label class="dropdown-item">
										<input
											type="checkbox"
											class="form-check-input me-2"
											[checked]="
												isStateSelected(
													GameProductionState.Prototype
												)
											"
											(change)="
												toggleState(
													GameProductionState.Prototype
												)
											"
										/>
										Prototyyppi
									</label>
								</li>
							</ul>
						</div>
					</div>
				</div>
			} @else {
				<div class="col-md-4">
					<!-- Empty column when state selector is hidden -->
				</div>
			}

			<div class="col">
				<!-- Grouping Dropdown -->
				<div ngbDropdown class="dropdown w-100">
					<button
						class="btn btn-outline-secondary dropdown-toggle w-100"
						type="button"
						ngbDropdownToggle
						aria-expanded="false"
					>
						@switch (selectedGrouping) {
							@case ("none") {
								Ei ryhmittelyä
							}
							@case ("type") {
								Tyypin mukaan
							}
							@case ("category") {
								Lajin mukaan
							}
						}
					</button>
					<ul ngbDropdownMenu class="dropdown-menu">
						<li>
							<button
								class="dropdown-item"
								(click)="selectedGrouping = 'none'"
								[class.active]="selectedGrouping === 'none'"
							>
								Ei ryhmittelyä
							</button>
						</li>
						<li>
							<button
								class="dropdown-item"
								(click)="selectedGrouping = 'type'"
								[class.active]="selectedGrouping === 'type'"
							>
								Tyypin mukaan
							</button>
						</li>
						<li>
							<button
								class="dropdown-item"
								(click)="selectedGrouping = 'category'"
								[class.active]="selectedGrouping === 'category'"
							>
								Lajin mukaan
							</button>
						</li>
					</ul>
				</div>
			</div>

			<div class="col">
				<!-- Tag Filter Dropdown -->
				<div ngbDropdown class="dropdown w-100">
					<button
						class="btn btn-outline-secondary dropdown-toggle w-100"
						type="button"
						ngbDropdownToggle
						aria-expanded="false"
					>
						Hakuehdot
						@if (
							selectedTags.length > 0 ||
							selectedCategories.length > 0
						) {
							<span class="badge bg-primary ms-2">{{
								selectedTags.length + selectedCategories.length
							}}</span>
						}
					</button>
					<ul ngbDropdownMenu class="dropdown-menu">
						@for (
							group of getTagGroupsForDropdown();
							track group.groupName
						) {
							<!-- Group header -->
							<li>
								<h6 class="dropdown-header">
									{{ group.groupName }}
								</h6>
							</li>

							<!-- Group items -->
							@for (item of group.items; track item.value) {
								<li>
									<button
										class="dropdown-item d-flex justify-content-between align-items-center"
										[class.disabled]="!item.available"
										[style.opacity]="
											item.available ? '1' : '0.5'
										"
										[style.cursor]="
											item.available
												? 'pointer'
												: 'not-allowed'
										"
										(click)="
											item.available
												? toggleGroupedItem(item)
												: null
										"
									>
										<span
											[class.text-muted]="!item.available"
										>
											{{ item.displayText }}
										</span>
										@if (isGroupedItemSelected(item)) {
											<i
												class="bi bi-check text-success"
											></i>
										}
									</button>
								</li>
							}

							<!-- Divider after group (except last) -->
							@if (
								$index < getTagGroupsForDropdown().length - 1
							) {
								<li><hr class="dropdown-divider" /></li>
							}
						}
					</ul>
				</div>
			</div>
		</div>

		<!-- Selected Filters Display -->

		<div class="row mb-3">
			<div class="col">
				<div class="d-flex flex-wrap gap-2 align-items-center">
					<!-- <span class="text-muted">Aktiiviset suodattimet:</span> -->

					<!-- Selected Tags -->
					@for (tag of selectedTags; track tag) {
						<span
							class="badge bg-primary d-flex align-items-center"
						>
							{{ gameTagDisplayText[tag] }}
							<button
								type="button"
								class="btn-close btn-close-white btn-sm ms-2"
								aria-label="Poista tagi"
								(click)="toggleTag(tag)"
							></button>
						</span>
					}

					<!-- Selected Categories -->
					@for (category of selectedCategories; track category) {
						<span
							class="badge bg-success d-flex align-items-center"
						>
							{{ gameCategoryDisplayText[category] }}
							<button
								type="button"
								class="btn-close btn-close-white btn-sm ms-2"
								aria-label="Poista kategoria"
								(click)="toggleCategory(category)"
							></button>
						</span>
					}

					<!-- Selected States -->

					<!-- @for (state of selectedStates; track state) {
								<span
									class="badge bg-info d-flex align-items-center btn-sm"
								>
									@switch (state) {
										@case (GameProductionState.Production) {
											Tuotanto
										}
										@case (GameProductionState.Beta) {
											Beta
										}

										@case (GameProductionState.Alpha) {
											Alpha
										}
										@case (GameProductionState.Prototype) {
											Prototyyppi
										}
									}
									<button
										type="button"
										class="btn-close btn-close-white btn-sm ms-2"
										aria-label="Poista tilasuodatin"
										(click)="toggleState(state)"
									></button>
								</span>
							
						} -->

					<!-- Clear All Button -->
					@if (
						selectedTags.length > 0 || selectedCategories.length > 0
					) {
						<button
							type="button"
							class="btn btn-sm btn-outline-secondary"
							(click)="
								selectedTags = [];
								selectedCategories = [];
								selectedStates = [
									GameProductionState.Production,
									GameProductionState.Beta,
									GameProductionState.Alpha,
									GameProductionState.Prototype,
								]
							"
						>
							Tyhjennä kaikki
						</button>
					}
				</div>
			</div>
		</div>

		<div class="pb-5"></div>

		<!-- Games Display -->
		@if (viewMode === "cards") {
			<!-- Card View -->
			@if (selectedGrouping === "none") {
				<!-- Ungrouped games -->
				<div
					class="row row-cols-1 row-cols-md-4 row-cols-lg-5 row-cols-xl-6 mb-5"
					style="margin: -0.5rem"
					@fadeScattered
				>
					@for (
						item of getFilteredGames();
						track item.title;
						let index = $index
					) {
						<div class="col" style="padding: 0.5rem">
							<div
								class="custom-card h-100 position-relative"
								style="cursor: pointer"
								[ngbTooltip]="item.description"
								[placement]="'bottom'"
								[tooltipClass]="'gameDescription'"
							>
								<div
									class="d-flex align-items-center justify-content-center h-100 w-100 flex-column text-white position-relative text-center background-color-layer"
									[style.background-color]="
										getCardBackgroundColor(item)
									"
								>
									<!-- Platform support icons at top-right -->
									<div
										class="position-absolute top-0 end-0 m-2 me-3 d-flex gap-1"
									>
										@if (item.desktopSupport) {
											<i
												class="bi bi-display text-white"
											></i>
										}
										@if (item.mobileSupport) {
											<i
												class="bi bi-phone text-white"
											></i>
										}
									</div>

									<!-- Development status badge -->
									<div
										class="status-badge"
										[style.border-left-color]="
											getStatusBadgeColor(item.state)
										"
										*ngIf="
											item.state !==
											GameProductionState.Production
										"
									>
										<span
											class="status-text"
											[innerHTML]="
												getStatusBadgeText(item.state)
											"
										></span>
									</div>

									<i
										class="bi main-icon mb-3 mt-4 fs-1"
										[class]="item.thumbnailClass"
									></i>
									<div class="card-title ps-2 pe-2">
										{{ item.title }}
									</div>
								</div>
								<!-- <div class="card-bottom">
									<div class="card-desc">
										{{ item.description }}
									</div>
									
								</div> -->

								<!-- Hover overlay with buttons -->
								<div class="card-hover-overlay">
									<!-- Main action buttons centered -->
									<div class="d-flex flex-column gap-1 px-3">
										<button
											class="btn btn-primary btn-lg"
											(click)="
												$event.stopPropagation();
												SelectPlugin(
													item,
													'editor',
													AutomaticContentGeneration.DoNothing
												)
											"
										>
											<i class="bi bi-plus me-1"></i>Luo
											uusi
										</button>
										<div ngbDropdown class="d-grid">
											<button
												class="btn btn-primary dropdown-toggle btn-lg"
												type="button"
												ngbDropdownToggle
												[disabled]="
													(!item.supportAutoGeneration &&
														!item.supportAutoGenerationWithManualSettings) ||
													sourceMaterialService
														.SelectedArticles
														.length === 0
												"
												[ngbTooltip]="
													sourceMaterialService
														.SelectedArticles
														.length === 0
														? 'Valitse ensin lähdemateriaalia automaattista luontia varten.'
														: !item.supportAutoGeneration &&
															  !item.supportAutoGenerationWithManualSettings
															? 'Tämä pelipohja ei tue automaattista luontia.'
															: ''
												"
												(click)="
													$event.stopPropagation()
												"
											>
												<i class="bi bi-stars me-1"></i
												>Luo automaattisesti...
											</button>
											<ul
												ngbDropdownMenu
												class="dropdown-menu"
											>
												<li>
													<button
														class="dropdown-item"
														[disabled]="
															!item.supportAutoGeneration
														"
														[ngbTooltip]="
															!item.supportAutoGeneration
																? 'Tämä pelipohja ei tue automaattista luontia.'
																: ''
														"
														(click)="
															$event.stopPropagation();
															SelectPlugin(
																item,
																'editor',
																AutomaticContentGeneration.GenerateInBackgroundWithDefaultSettings
															)
														"
													>
														<i
															class="bi bi-stars me-1"
														></i
														>Luo heti
													</button>
												</li>
												<li>
													<button
														class="dropdown-item"
														[disabled]="
															!item.supportAutoGenerationWithManualSettings
														"
														[ngbTooltip]="
															!item.supportAutoGenerationWithManualSettings
																? 'Tämä pelipohja ei tue automaattista luontia asetuksilla.'
																: ''
														"
														(click)="
															$event.stopPropagation();
															SelectPlugin(
																item,
																'editor',
																AutomaticContentGeneration.OpenSettings
															)
														"
													>
														<i
															class="bi bi-gear me-1"
														></i
														>Määritä...
													</button>
												</li>
											</ul>
										</div>

										<button
											class="btn btn-primary btn-lg"
											(click)="
												$event.stopPropagation();
												SelectPlugin(item, 'demo')
											"
										>
											<i class="bi bi-eye"></i>
											Kokeile
										</button>

										<!-- Platform support text -->
										<div class="mt-2 text-center d-none">
											@if (
												item.desktopSupport &&
												item.mobileSupport
											) {
												<small class="text-white"
													>Peli toimii sekä isolla
													näytöllä että
													mobiililaitteilla.</small
												>
											} @else if (
												item.desktopSupport &&
												!item.mobileSupport
											) {
												<small class="text-white"
													>Peli toimii vain isolla
													näytöllä</small
												>
											} @else if (
												!item.desktopSupport &&
												item.mobileSupport
											) {
												<small class="text-white"
													>Peli toimii vain
													mobiililaitteilla.</small
												>
											}
										</div>
									</div>
								</div>

								<!-- Preview button positioned on the card itself -->
								<!-- <button
									type="button"
									class="btn btn-link preview-btn-card fs-4"
									(click)="
										$event.stopPropagation();
										SelectPlugin(item, 'demo')
									"
								>
									<i class="bi bi-eye"></i>
								</button> -->
							</div>
						</div>
					}
				</div>
			} @else {
				<!-- Grouped games -->
				@let groupedGames = getGroupedGames();

				@if (groupedGames) {
					@for (
						group of getSortedGroupedGames(groupedGames);
						track group.key
					) {
						<div class="mb-5">
							<h5 class="mb-3">
								<i
									class="bi bi-folder-fill text-primary me-2"
								></i
								>{{ group.key }}
								<span class="badge bg-secondary ms-2">{{
									group.value.length
								}}</span>
							</h5>
							<div
								class="row row-cols-1 row-cols-md-4 row-cols-lg-8 row-cols-xl-10"
								style="margin: -0.5rem"
								@fadeScattered
							>
								@for (
									item of group.value;
									track item.title;
									let index = $index
								) {
									<div class="col" style="padding: 0.5rem">
										<div
											class="custom-card h-100 position-relative"
											style="cursor: pointer"
										>
											<div
												class="card-top text-white position-relative"
												[style.background-color]="
													getCardBackgroundColor(item)
												"
											>
												<!-- Platform support icons at top-right -->
												<div
													class="position-absolute top-0 end-0 m-2 me-3 d-flex gap-1"
												>
													@if (item.desktopSupport) {
														<i
															class="bi bi-display text-white"
														></i>
													}
													@if (item.mobileSupport) {
														<i
															class="bi bi-phone text-white"
														></i>
													}
												</div>

												<!-- Development status badge -->
												<div
													class="status-badge"
													[style.border-left-color]="
														getStatusBadgeColor(
															item.state
														)
													"
													*ngIf="
														item.state !==
														GameProductionState.Production
													"
												>
													<span
														class="status-text"
														[innerHTML]="
															getStatusBadgeText(
																item.state
															)
														"
													></span>
												</div>

												<div
													class="position-absolute top-0 end-0 p-2 d-flex gap-1"
												>
													<!-- Preset indicator -->
													<!-- <span
													*ngIf="item.preset"
													class="badge bg-light text-dark d-flex align-items-center"
													title="Esiasetus"
												>
													<i
														class="bi bi-star-fill"
														style="
															font-size: 0.7rem;
														"
													></i>
												</span> -->
													<!-- Prototype indicator -->
													<!-- <span
													*ngIf="
														item.state ===
														GameProductionState.Prototype
													"
													class="badge bg-warning text-dark d-flex align-items-center"
													title="Prototyyppi"
												>
													<i class="bi bi-gear-fill" style="font-size: 0.7rem;"></i>
												</span> -->
												</div>
												<i
													class="bi main-icon mb-3 mt-4"
													[class]="
														item.thumbnailClass
													"
												></i>
												<div
													class="card-title ps-2 pe-2"
												>
													{{ item.title }}
												</div>
											</div>
											<div class="card-bottom">
												<div class="card-desc">
													{{ item.description }}
												</div>
											</div>

											<!-- Hover overlay with buttons -->
											<div class="card-hover-overlay">
												<!-- Main action buttons centered -->
												<div
													class="d-flex flex-column gap-2 px-3"
												>
													<button
														class="btn btn-primary"
														(click)="
															$event.stopPropagation();
															SelectPlugin(
																item,
																'editor',
																AutomaticContentGeneration.DoNothing
															)
														"
													>
														<i
															class="bi bi-plus-circle me-2"
														></i
														>Luo uusi
													</button>
													<div
														ngbDropdown
														class="d-grid"
													>
														<button
															class="btn btn-primary dropdown-toggle"
															type="button"
															ngbDropdownToggle
															[disabled]="
																(!item.supportAutoGeneration &&
																	!item.supportAutoGenerationWithManualSettings) ||
																sourceMaterialService
																	.SelectedArticles
																	.length ===
																	0
															"
															[ngbTooltip]="
																sourceMaterialService
																	.SelectedArticles
																	.length ===
																0
																	? 'Valitse ensin lähdemateriaalia automaattista luontia varten.'
																	: !item.supportAutoGeneration &&
																		  !item.supportAutoGenerationWithManualSettings
																		? 'Tämä pelipohja ei tue automaattista luontia.'
																		: ''
															"
															(click)="
																$event.stopPropagation()
															"
														>
															<i
																class="bi bi-stars me-2"
															></i
															>Luo
															automaattisesti...
														</button>
														<ul
															ngbDropdownMenu
															class="dropdown-menu"
														>
															<li>
																<button
																	class="dropdown-item"
																	[disabled]="
																		!item.supportAutoGeneration
																	"
																	[ngbTooltip]="
																		!item.supportAutoGeneration
																			? 'Tämä pelipohja ei tue automaattista luontia.'
																			: ''
																	"
																	(click)="
																		$event.stopPropagation();
																		SelectPlugin(
																			item,
																			'editor',
																			AutomaticContentGeneration.GenerateInBackgroundWithDefaultSettings
																		)
																	"
																>
																	<i
																		class="bi bi-stars me-2"
																	></i
																	>Luo heti
																</button>
															</li>
															<li>
																<button
																	class="dropdown-item"
																	[disabled]="
																		!item.supportAutoGenerationWithManualSettings
																	"
																	[ngbTooltip]="
																		!item.supportAutoGenerationWithManualSettings
																			? 'Tämä pelipohja ei tue automaattista luontia asetuksilla.'
																			: ''
																	"
																	(click)="
																		$event.stopPropagation();
																		SelectPlugin(
																			item,
																			'editor',
																			AutomaticContentGeneration.OpenSettings
																		)
																	"
																>
																	<i
																		class="bi bi-gear me-2"
																	></i
																	>Käytä
																	asetuksia...
																</button>
															</li>
														</ul>
													</div>

													<button
														type="button"
														class="btn btn-primary mt-3"
														(click)="
															$event.stopPropagation();
															SelectPlugin(
																item,
																'demo'
															)
														"
													>
														<i
															class="bi bi-eye"
														></i>
														Kokeile
													</button>

													<!-- Platform support text -->
													<div
														class="mt-2 text-center d-none"
													>
														@if (
															item.desktopSupport &&
															item.mobileSupport
														) {
															<small
																class="text-white"
																>Peli toimii
																sekä isolla
																näytöllä että
																mobiililaitteilla.</small
															>
														} @else if (
															item.desktopSupport &&
															!item.mobileSupport
														) {
															<small
																class="text-white"
																>Peli toimii
																vain isolla
																näytöllä</small
															>
														} @else if (
															!item.desktopSupport &&
															item.mobileSupport
														) {
															<small
																class="text-white"
																>Peli toimii
																vain
																mobiililaitteilla.</small
															>
														}
													</div>
												</div>
											</div>

											<!-- Preview button positioned on the card itself -->
											<!-- <button
												type="button"
												class="btn btn-link preview-btn-card"
												(click)="
													$event.stopPropagation();
													SelectPlugin(item, 'demo')
												"
											>
												<i class="bi bi-eye fs-3"></i>
											</button> -->
										</div>
									</div>
								}
							</div>
						</div>
					}
				}
			}
		} @else {
			<!-- Row View -->
			@if (selectedGrouping === "none") {
				<!-- Ungrouped games - Row view -->
				<div class="row-view mb-5" @fadeScattered>
					@for (
						item of getFilteredGames();
						track item.title;
						let index = $index
					) {
						<div
							class="game-row"
							(click)="SelectPlugin(item, 'editor')"
						>
							<div class="game-row-content">
								<div class="game-row-icon">
									<i
										class="bi"
										[class]="item.thumbnailClass"
									></i>
								</div>
								<div class="game-row-info">
									<div class="game-row-title">
										{{ item.title }}
									</div>
									<div class="game-row-description">
										{{ item.description }}
									</div>
								</div>
								<div class="game-row-status">
									@if (
										item.state !==
										GameProductionState.Production
									) {
										<span
											class="badge"
											[style.background-color]="
												getStatusBadgeColor(item.state)
											"
											[style.color]="
												item.state ===
												GameProductionState.Beta
													? 'var(--bs-dark)'
													: 'white'
											"
										>
											<span
												[innerHTML]="
													getStatusBadgeText(
														item.state
													)
												"
											></span>
										</span>
									}
								</div>
								<div class="game-row-actions">
									<button
										type="button"
										class="btn btn-outline-secondary"
										(click)="
											$event.stopPropagation();
											SelectPlugin(item, 'demo')
										"
										title="Esikatselu"
									>
										<i class="bi bi-eye fs-3"></i>
									</button>
								</div>
							</div>
						</div>
					}
				</div>
			} @else {
				<!-- Grouped games - Row view -->
				@let groupedGames = getGroupedGames();

				@if (groupedGames) {
					@for (
						group of getSortedGroupedGames(groupedGames);
						track group.key
					) {
						<div class="mb-5">
							<h5 class="mb-3">
								<i
									class="bi bi-folder-fill text-primary me-2"
								></i>
								{{ group.key }}
								<span class="badge bg-secondary ms-2">{{
									group.value.length
								}}</span>
							</h5>
							<div class="row-view" @fadeScattered>
								@for (
									item of group.value;
									track item.title;
									let index = $index
								) {
									<div
										class="game-row"
										(click)="SelectPlugin(item, 'editor')"
									>
										<div class="game-row-content">
											<div class="game-row-icon">
												<i
													class="bi"
													[class]="
														item.thumbnailClass
													"
												></i>
											</div>
											<div class="game-row-info">
												<div class="game-row-title">
													{{ item.title }}
												</div>
												<div
													class="game-row-description"
												>
													{{ item.description }}
												</div>
											</div>
											<div class="game-row-status">
												@if (
													item.state !==
													GameProductionState.Production
												) {
													<span
														class="badge"
														[style.background-color]="
															getStatusBadgeColor(
																item.state
															)
														"
														[style.color]="
															item.state ===
															GameProductionState.Beta
																? 'var(--bs-dark)'
																: 'white'
														"
													>
														<span
															[innerHTML]="
																getStatusBadgeText(
																	item.state
																)
															"
														></span>
													</span>
												}
											</div>
											<div class="game-row-actions">
												<button
													type="button"
													class="btn btn-outline-secondary btn-sm"
													(click)="
														$event.stopPropagation();
														SelectPlugin(
															item,
															'demo'
														)
													"
													title="Esikatselu"
												>
													<i class="bi bi-eye"></i>
												</button>
											</div>
										</div>
									</div>
								}
							</div>
						</div>
					}
				}
			}
		}
	</div>
</div>
